import { useEffect, useState } from 'react'

export function useDebouncedValue<T>(value: T, delay = 300): T {
    const [debouncedValue, setDebouncedValue] = useState(value)

    useEffect(() => {
        const timeoutId = setTimeout(() => setDebouncedValue(value), delay)
        return () => clearTimeout(timeoutId)
    }, [value, delay])

    return debouncedValue
}
